<script setup lang="ts">
  import MarkdownIt from "markdown-it";
  import { computed } from "vue";

  // 更新 prop 名为 modelValue 以符合 Vue 3 约定
  const props = defineProps({
    modelValue: {
      type: String,
      required: true,
    },
  });

  const md = new MarkdownIt({
    html: true,
    linkify: true,
    typographer: true,
    langPrefix: "markdown-it-",
  });

  const html = computed(() => {
    if (props.modelValue) {
      return md.render(props.modelValue);
    }
    return null;
  });
</script>

<template>
  <div class="markdown-it" v-html="html"></div>
</template>

<style lang="less" scoped>
  .markdown-it {
    font-size: 16px;
    color: #1d2129;

    :deep(img),
    :deep(video) {
      max-width: 100%;
    }

    :deep(p) {
      margin-bottom: 20px;
      line-height: 28px;
    }

    :deep(h2) {
      padding: 20px 0;
      font-size: 20px;
      font-weight: 600;
      line-height: 33px;
      color: #1d2129;
    }

    :deep(h3) {
      padding: 20px 0;
      font-size: 20px;
      font-weight: 600;
      line-height: 33px;
      color: #1d2129;
    }

    :deep(table) {
      width: 100%;

      thead {
        background: #f8f8f8;
      }

      tr:nth-child(even):not([bgcolor]) {
        background: #f8f8f8;
      }

      td,
      th {
        padding: 8px;
        border: solid 1px rgba(23, 26, 29, 14%);
      }
    }
  }
</style>
